<template>
    <div :class="divClass">
        <button type="button" class="btn btn-secondary btn-lg text-uppercase"
            :class="buttonClass(selected == -1)"
            @click="select(-1)"
        >
            {{ $t('overview.'+registration.degree.lang+'-global-feedback') }}
            <i :class="arrowClass" v-if="selected == -1"></i>
        </button>

        <button type="button" class="btn btn-secondary btn-lg domains"
            :class="buttonClass(selected == domain.id)"
            v-for="(domain, index) in domains" :key="index"
            @click="select(domain.id)"
        >
            <rating
                :options="ratingOptions"
                :value="rating(domain.id)"
                :disabled="true"
                v-if="showRating(domain.id)"
            ></rating>
            {{ domain['name_'+registration.degree.lang] }}
            <i :class="arrowClass" v-if="selected == domain.id"></i>
        </button>
    </div>
</template>

<script>
    import Rating from '../Rating'

    export default {

        components: {
            Rating
        },

        props: {

            registration: {
                type: Object,
                required: true
            },

            domains: {
                type: Object,
                required: true
            },

            simulations: {
                type: Array,
                required: true
            },

            ratingOptions: {
                type: Array,
                required: true
            },

            compact: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                selected: -1
            }
        },

        computed: {

            divClass() {
                return this.compact
                    ? 'mb-3'
                    : 'mb-5'
            },

            arrowClass() {
                return this.compact
                    ? ''
                    : 'fas float-right fa-angle-right'
            },

            pictoClass() {
                return this.compact
                    ? 'float-left mr-1'
                    : 'float-left'
            },
        },

        methods: {

            buttonClass(active) {
                let buttonClass = this.compact ? 'mb-1' : 'btn-block'
                if (active) {
                    buttonClass += ' active'
                }
                return buttonClass
            },

            showRating(id) {
                return this.rating(id) != -1
            },

            rating(id) {
                let lastRating = -1
                for (let simulation of this.simulations) {
                    if (simulation.private || !simulation.assessment || !simulation.state || simulation.state.empty || !simulation.state.published) {
                        continue
                    }
                    if (!this.canShowReview(simulation)) {
                        continue
                    }
                    if (simulation.state.domains[id] != -1 && simulation.state.domains[id] !== null) {
                        lastRating = simulation.state.domains[id]
                    }
                }
                return lastRating
            },

            canShowReview(simulation) {
                if (this.$permissions.hasRight('dashboard.overviews.always')) {
                    return true
                }
                if (simulation.private) {
                    return false
                }
                if (this.$permissions.hasRight('dashboard.overviews.closed')) {
                    return this.simulationClosed(simulation)
                }
                if (this.$permissions.hasRight('dashboard.overviews.date-or-closed')) {
                    if (simulation.assessment) {
                        return this.simulationAfterDate(simulation)
                    } else {
                        return this.simulationClosed(simulation)
                    }
                }
                return false
            },

            simulationClosed(simulation) {
                return simulation.state.date
                    && new Date(simulation.state.date) <= new Date()
            },

            simulationAfterDate(simulation) {
                return simulation.state.meta
                    && simulation.state.meta.learner_access_date
                    && new Date(simulation.state.meta.learner_access_date) <= new Date()
            },

            select(index) {
                this.selected = index
                this.$emit('input', index)
            },
        }
    }
</script>

<style scoped>

    .btn.active:hover, .btn.active:focus {
        box-shadow: none !important;
        transform: none !important;
        border-color: none !important;
    }
    i {
        position: relative;
        top: 3px;
    }
    .domains >>> .rating {
        float: left;
        padding: 0 !important;
    }
    .domains >>> .rating .btn-icon-only {
        width: 1.5rem;
        height: 1.5rem;
    }

</style>